import {
  SET_TOWN,
  INIT_TOWN,
  INIT_TOWN_ERROR,
  NOT_FOUND_TOWN,
} from '../constants/actions'
import { fetchTown } from '../modules/portal-remote/portalService'

export const setTown = town => ({
  type: SET_TOWN,
  town,
})

export const initTownIfHave = () => dispatch => {
  const url = window.location.href
  const urls = url.split('/')
  const townID = urls[urls.indexOf('towns') + 1]
  if (townID && urls.includes('towns')) {
    return fetchTown(townID)
      .then(result => {
        return dispatch({
          type: INIT_TOWN,
          town: result,
        })
      })
      .catch(error => {
        return dispatch({
          type: INIT_TOWN_ERROR,
          message: error.message,
        })
      })
  } else {
    return dispatch({ type: NOT_FOUND_TOWN })
  }
}



// WEBPACK FOOTER //
// ./src/actions/town.js